import _ from 'lodash';

function formatToTimestamp(dateStr) {
	if (!dateStr) return null;
	const date = new Date(dateStr);
	return isNaN(date.getTime()) ? null : date.toISOString();
}

export function transformSchemaToSegmentState(schema) {
	return {
		ageRange: [schema.age_min, schema.age_max],
		ageRangeEnabled: schema.age_min !== null || schema.age_max !== null,
		allergies: schema.allergies,
		bmi_max: schema.bmi_max,
		bmi_min: schema.bmi_min,
		bmiEnabled: schema.bmi_min !== null || schema.bmi_max !== null,
		conditions: schema.conditions,
		contactMethod: schema.preferred_contact_method,
		contactMethodEnabled: schema.preferred_contact_method !== null,
		ethnicity: schema.ethnicity,
		ethnicityEnabled: schema.ethnicity !== null,
		gender: schema.gender,
		genderEnabled: schema.gender !== null,
		height_max_in: schema.height_max_in,
		height_min_in: schema.height_min_in,
		heightEnabled: schema.height_min_in !== null || schema.height_max_in !== null,
		id: schema.id,
		interactionFrequency: schema.interaction_frequency,
		interactionFrequencyEnabled: schema.interaction_frequency !== null,
		language: schema.preferred_language,
		languageEnabled: schema.preferred_language !== null,
		lastInteraction: schema.last_interaction_date?.length ? schema.last_interaction_date : null,
		lastInteractionEnabled: schema.last_interaction_date !== null,
		locationEnabled: schema.location_radius_miles !== null || schema.location_coordinates !== null,
		locationRadius: schema.location_radius_miles,
		measurementSystem: 'imperial',
		medications: schema.medications,
		participationStatus: schema.participation_status,
		participationStatusEnabled: schema.participation_status !== null,
		// FIXME: Convert schema.location into position
		position: { lat: 40.7, lng: -73.9, label: 'New York' },
		previousTrial: schema.previous_trial_participation,
		previousTrialEnabled: schema.previous_trial_participation !== null,
		race: schema.race,
		raceEnabled: schema.race !== null,
		responseStatus: schema.response_status,
		responseStatusEnabled: schema.response_status !== null,
		procedures: [],
		segmentName: schema.name,
		smoking: schema.smoker_status,
		smokingEnabled: schema.smoker_status !== null,
		trialPhase: schema.trial_phase,
		trialPhaseEnabled: schema.trial_phase !== null,
		weight_max_lb: schema.weight_max_lb,
		weight_min_lb: schema.weight_min_lb,
		weightEnabled: schema.weight_min_lb !== null || schema.weight_max_lb !== null,
		subjectFilterEnabled: schema.subject_filters_json !== null,
		subject_filters_json: schema.subject_filters_json ? JSON.parse(schema.subject_filters_json) : null,
	};
}

export function transformSegmentStateToSchema({ formData: segment, oldFormData: old_segment }) {
	return {
		input: {
			segments: {
				...(segment.id ? { id: segment.id } : undefined),
				name: segment.segmentName,
				age_max: segment.ageRangeEnabled ? segment.ageRange[1] : null,
				age_min: segment.ageRangeEnabled ? segment.ageRange[0] : null,
				bmi_max: segment.bmiEnabled ? segment.bmi_max : null,
				bmi_min: segment.bmiEnabled ? segment.bmi_min : null,
				//bmi_category: segment.bmiEnabled ? segment.bmi : null,
				ethnicity: segment.ethnicityEnabled ? segment.ethnicity.value : null,
				gender: segment.genderEnabled ? segment.gender : null,
				height_max_in: segment.heightEnabled ? Number(segment.height_max_in) || null : null,
				height_min_in: segment.heightEnabled ? Number(segment.height_min_in) || null : null,
				interaction_frequency: segment.interactionFrequencyEnabled ? segment.interactionFrequency || null : null,
				last_interaction_date: segment.lastInteractionEnabled ? segment.lastInteraction : null,
				...(segment.locationEnabled ? {
					location_coordinates: segment.position
						? `${segment.position.lat},${segment.position.lng}`
						: null,
					location_radius_miles: segment.measurementSystem === 'imperial'
						? segment.locationRadius
						: segment.locationRadius * 0.621371
				} : {
					location_coordinates: null,
					location_radius_miles: null
				}),
				participation_status: segment.participationStatusEnabled ? segment.participationStatus?.value || segment.participationStatus || null : null,
				preferred_contact_method: segment.contactMethodEnabled ? segment.contactMethod || null : null,
				preferred_language: segment.languageEnabled ? segment.language?.value : null,
				previous_trial_participation: segment.previousTrialEnabled ? segment.previousTrial || null : null,
				race: segment.raceEnabled ? segment.race?.value : null,
				response_status: segment.responseStatusEnabled ? segment.responseStatus || null : null,
				smoker_status: segment.smokingEnabled ? segment.smoking || null : null,
				subject_filters_json: segment.subject_filters_json ? JSON.stringify(segment.subject_filters_json) : null,
				trial_phase: segment.trialPhaseEnabled ? segment.trialPhase || null : null,
				weight_max_lb: segment.weightEnabled ? Number(segment.weight_max_lb) || null : null,
				weight_min_lb: segment.weightEnabled ? Number(segment.weight_min_lb) || null : null,
			},
			allergies: segment.allergies?.map(a => ({ id: a.id || a })) || [],
			conditions: segment.conditions?.map(c => ({ id: c.id || c })) || [],
			medications: segment.medications?.map(m => ({ id: m.id || m })) || []
		},
		input_delete: old_segment ? [
			...(_.differenceBy(old_segment.allergies, segment.allergies, 'id').map(a => ({ key: 'allergies', id: a.id })) || []),
			...(_.differenceBy(old_segment.conditions, segment.conditions, 'id').map(a => ({ key: 'conditions', id: a.id })) || []),
			...(_.differenceBy(old_segment.medications, segment.medications, 'id').map(a => ({ key: 'medications', id: a.id })) || [])

		] : undefined
	};
}
